import type { JSX } from 'react';

import { Badge } from '@/components/ui/badge';

import type { ActivityGroup } from '../../model/activity-display';
import ActivityRow from './ActivityRow';

interface ActivityFeedProps {
  groups: ActivityGroup[];
  total: number;
  currentPage: number;
  totalPages: number;
}

const ActivityFeed = ({ groups, total, currentPage, totalPages }: ActivityFeedProps): JSX.Element => (
  <>
    <div className="flex items-center justify-between">
      <Badge variant="secondary" className="font-body">
        {total} resultado{total !== 1 ? 's' : ''}
      </Badge>
      <span className="text-xs text-text-muted font-body">
        Página {currentPage} de {totalPages}
      </span>
    </div>

    <div className="flex flex-col gap-4">
      {groups.map((group) => (
        <section key={`${group.label}-${group.items[0].id}`} className="flex flex-col gap-2">
          <h4 className="m-0 px-1 text-[11px] font-semibold uppercase tracking-wider text-text-subtle font-body">
            {group.label}
          </h4>
          <ul className="m-0 flex list-none flex-col gap-2 p-0">
            {group.items.map((item) => (
              <ActivityRow key={`${item.domain}-${item.id}`} item={item} />
            ))}
          </ul>
        </section>
      ))}
    </div>
  </>
);

export default ActivityFeed;
